export function is_socket_connecting_or_open(socket) {
  if (!socket) return false;
  return [WebSocket.CONNECTING, WebSocket.OPEN].includes(socket.readyState);
}

export function attach_socket_handlers(client, socket) {
  socket.onopen = (event) => client.handle_open(event);
  socket.onclose = (event) => client.handle_close(event);
  socket.onerror = (event) => client.invoke_callback("on_error", event);
  socket.onmessage = (event) => client.handle_message(event);
}

export function create_socket(url) {
  return new WebSocket(url);
}

export function close_socket(socket) {
  if (socket) socket.close(1000, "client_disconnect");
}

export function calculate_reconnect_delay(options, attempts) {
  const base_delay = Math.min(
    options.reconnect_max_delay,
    options.reconnect_min_delay * (2 ** (attempts - 1))
  );
  const jitter = Math.floor(Math.random() * options.reconnect_jitter);
  return base_delay + jitter;
}
